import logInboxReminderOffsetOption from './logInboxReminderOffsetOption';
import type { InboxReminder } from 'owa-graph-schema';

/**
 * Logs the reminder offset for newly added or updated inbox reminders. Skip the one for deleted reminders.
 * @param curInboxReminders to update
 * @param originalInboxReminders previous inbox reminders
 */
export default function logInboxReminderOffsetsForCompose(
    curInboxReminders: InboxReminder[] | undefined,
    originalInboxReminders: InboxReminder[] | undefined
) {
    if (!curInboxReminders) {
        // No-op if there is no inbox reminder
        return;
    }

    const originalReminderOffsetMap = {};
    originalInboxReminders &&
        originalInboxReminders.forEach(reminder => {
            originalReminderOffsetMap[reminder.Id] = reminder.ReminderOffset;
        });

    curInboxReminders.forEach(curReminder => {
        // A reminder offset is changed if
        // - it is a new reminder, i.e not in the originalEvent.InboxReminders
        // - or the reminder offset has been changed
        if (
            !originalReminderOffsetMap[curReminder.Id] ||
            originalReminderOffsetMap[curReminder.Id] !== curReminder.ReminderOffset
        ) {
            logInboxReminderOffsetOption(curReminder.ReminderOffset);
        }
    });
}
